import { useCallback } from "react";

import { useLocale } from "./LocaleContext";
import type { AppLocale } from "./types";

export interface Translatable {
  i18n?: Partial<
    Record<string, Record<string, string | null | undefined> | undefined>
  >;
}

/** Russian field, or the en/az copy when that locale has one. */
export function localized(
  record: (Translatable & object) | null | undefined,
  field: string,
  locale: AppLocale,
): string {
  if (!record) {
    return "";
  }
  if (locale !== "ru") {
    const translated = record.i18n?.[locale]?.[field];
    if (typeof translated === "string" && translated.trim() !== "") {
      return translated;
    }
  }
  const original = (record as Record<string, unknown>)[field];
  return typeof original === "string" ? original : "";
}

export function useLocalized() {
  const { locale } = useLocale();
  return useCallback(
    (record: (Translatable & object) | null | undefined, field: string) =>
      localized(record, field, locale),
    [locale],
  );
}
